import { FormattedMessage, FormattedNumber } from 'react-intl'

import { TrophyIcon } from '@gto/ui/icons/solid'
import { Typography } from '@gto/ui/typography'

import { RakeRaceRules } from '@/pages/promotion/components/rake-race/rake-race-rules'
import { RakeRaceTable } from '@/pages/promotion/components/rake-race/rake-race-table'

export const RakeRaceRoute = () => {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center text-primary-main">
            <TrophyIcon
              height={48}
              width={48}
            />
          </div>
          <Typography variant="h4">
            <FormattedMessage
              id="promo.rakeRace.title"
              values={{
                prize: (
                  <FormattedNumber
                    currency="USD"
                    minimumFractionDigits={0}
                    style="currency"
                    value={20_000}
                  />
                ),
              }}
            />
          </Typography>
        </div>
        <Typography
          color="text.secondary"
          variant="body1"
        >
          <FormattedMessage id="promo.rakeRace.description" />
        </Typography>
      </div>
      <RakeRaceTable />
      <RakeRaceRules />
    </div>
  )
}
